import React, { createContext } from 'react';
import PropTypes from 'prop-types';

/**
 * Creates a context for managing user-related state.
 *
 * @type {React.Context<null>}
 */
export const UserContext = createContext(null);

/**
 * Provider component for the UserContext.
 *
 * @component
 * @param {Object} props - Component properties.
 * @param {React.ReactNode} props.children - The child node(s) to render.
 * @returns {JSX.Element} The UserContext provider component.
 */
export const UserProvider = ({ children }) => (
	<UserContext.Provider value={null}>
		{children}
	</UserContext.Provider>
);

UserProvider.propTypes = {
	children: PropTypes.node.isRequired
};
